export default "__VITE_ASSET__B6z6MdPt__"